var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77777 0.522195C9.34819 0.092618 8.65171 0.092618 8.22213 0.522195L0.522134 8.22219C0.092557 8.65177 0.092557 9.34825 0.522134 9.77783C0.95171 10.2074 1.64819 10.2074 2.07777 9.77783L2.39995 9.45565V16.7C2.39995 17.3075 2.89244 17.8 3.49995 17.8H5.69995C6.30746 17.8 6.79995 17.3075 6.79995 16.7V14.5C6.79995 13.8925 7.29244 13.4 7.89995 13.4H10.1C10.7075 13.4 11.2 13.8925 11.2 14.5V16.7C11.2 17.3075 11.6924 17.8 12.2999 17.8H14.5C15.1075 17.8 15.5999 17.3075 15.5999 16.7V9.45565L15.9221 9.77783C16.3517 10.2074 17.0482 10.2074 17.4778 9.77783C17.9073 9.34825 17.9073 8.65177 17.4778 8.22219L9.77777 0.522195Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4818ff0c14052d5e271b93872b25f3df.svg";
export { ForwardRef as ReactComponent };